import { render, staticRenderFns } from "./StudentClearance.vue?vue&type=template&id=197014db&scoped=true"
import script from "./StudentClearance.vue?vue&type=script&lang=js"
export * from "./StudentClearance.vue?vue&type=script&lang=js"
import style0 from "./StudentClearance.vue?vue&type=style&index=0&id=197014db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197014db",
  null
  
)

export default component.exports